import { create } from '@theme/create';

export const themed = create(
  new (function () {
    this.badgeWrapper = (isPdp) => ({
      position: 'absolute',
      top: isPdp ? [0, 10] : 0,
      left: isPdp ? [0, 10] : 0,
      display: 'flex',
      alignItems: 'center',
      height: '24px',
    });
    this.badge = (isPdp) => ({
      variant: 'text.label.1',
      fontSize: '11px',
      textTransform: 'capitalize',
      zIndex: 1,
      height: '24px',
      lineHeight: '24px',
      bg: 'red',
      color: 'white',
      px: '11px',
      pointerEvents: 'none',
    });
    this.personalize = (isPdp) => ({
      ...this.badge(isPdp),
      color: (t) => t.colors.dark,
      padding: 0,
      height: '19px',
    });
  })()
);
